/**
 * 信息录入路由文件
 */
import PageEntryInformationIndex from '../pages/entryInformation/index.vue'
import PageEntryInformationGuardian from '../pages/entryInformation/guardian.vue'
import PageEntryInformationGuardianDetail from '../pages/entryInformation/guardianDetail.vue'
import PageEntryInformationForm from '../pages/entryInformation/form.vue'
import PageFaceLayout from '../pages/entryInformation/layout.vue'
import PageHomeSchool from '../pages/entryInformation/homeSchool.vue'
import PageOrg from '../pages/entryInformation/org.vue'
import { PAGE_IN_MODULE } from '@/utils/constUtils'
const modular = PAGE_IN_MODULE.face
export default [
  {
    path: '/entryInformation/index',
    name: 'PageEntryInformationIndex',
    component: PageEntryInformationIndex,
    meta: { modular, title: '信息录入', info: '信息录入———首页' }
  },
  {
    path: '/entryInformation/guardian/index',
    name: 'PageEntryInformationGuardian',
    component: PageEntryInformationGuardian,
    meta: { modular, title: '信息录入', info: '信息录入———首页' }
  },
  {
    path: '/entryInformation/guardian/detail',
    name: 'PageEntryInformationGuardianDetail',
    component: PageEntryInformationGuardianDetail,
    meta: { modular, title: '信息录入', info: '信息录入———首页' }
  },
  {
    path: '/entryInformation/form',
    name: 'PageEntryInformationForm',
    component: PageEntryInformationForm,
    meta: { modular, title: '身份信息管理', info: '身份信息管理———完善信息' }
  },
  {
    path: '/entryInformation/homeSchool',
    name: 'PageFaceLayout',
    component: PageFaceLayout,
    // meta: { modular, title: '身份信息管理', info: '身份信息管理———首页' },
    children: [
      {
        path: ':type/:id',
        name: 'PageHomeSchool',
        component: PageHomeSchool,
        meta: { modular, title: '身份信息管理', info: '身份信息管理———首页' }
      }
    ]
  },
  {
    path: '/entryInformation/org',
    name: 'PageFaceLayout',
    component: PageFaceLayout,
    // meta: { modular, title: '身份信息管理', info: '身份信息管理———首页' },
    children: [
      {
        path: ':id',
        name: 'PageOrg',
        component: PageOrg,
        meta: {
          modular,
          title: '教职工信息管理',
          info: '教职工信息管理———首页'
        }
      }
    ]
  }
]
